import * as t from "io-ts";

export const CompanyTraining = t.union([
  t.literal("training_required"),
  t.literal("training_scheduled"),
  t.literal("training_done"),
]);

export type CompanyTraining =
  | "training_required"
  | "training_scheduled"
  | "training_done";
